import {styled} from "@mui/material/styles"
import {Box as MUIBox, Tab as MUITab, Chip as MUIChip, Tabs as MUITabs, Typography} from "@mui/material"
import {breakpoints} from "@next/themes"

export const Box = styled(MUIBox)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0 0.75rem 0.75rem 0.5rem;
    flex-direction: row;
    align-items: center;
`

export const Title = styled("div")`
    font-size: 0.875rem;
    font-weight: 500;
    white-space: nowrap;
    padding: 0 0 0.2rem 0.3rem;
    color: ${({theme}) => theme.colours.palette.text.primary};

    @media (min-width: ${breakpoints.values.lg}px) {
        padding-left: 1rem;
        padding-bottom: 0;
    }
`

export const Wrapper = styled("div")`
    display: flex;
    min-height: 3rem;
    align-items: center;
`
export const Container = styled("div", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<{$show?: boolean}>`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1rem;
    width: 100%;
    height: ${({$show}) => ($show ? "auto" : "0px")};
    overflow-x: ${({$show}) => ($show ? "auto" : "hidden")};
`

export const StyledTitle = styled(Typography)`
    font-family: ${({theme}) => `${theme.colours.typography.subtitle2.fontFamily}, ${theme.colours.font.default}`};
    font-size: ${({theme}) => theme.colours.typography.subtitle2.fontSize};
    font-weight: ${({theme}) => theme.colours.typography.subtitle2.fontWeight};
    align-self: center;
`
export const Tabs = styled(MUITabs)`
    position: relative;
    width: 100%;
    margin: 0 0.25rem;
    .MuiTabs-scroller {
        width: 1px;
    }
`
interface TabsProps {
    isFirstChild: boolean
    isLastChild: boolean
}
export const Tab = styled(MUITab)<TabsProps>`
    padding: 0.25rem;
    min-width: 0;

    &.Mui-focusVisible {
        outline: 0;
    }
    padding-right: 0.65rem;
    ${({isFirstChild}) => isFirstChild && `margin-inline-start: auto;`};
    ${({isLastChild}) => isLastChild && `margin-inline-end: auto;padding-right: 1.5rem;`};

    @media (min-width: ${breakpoints.values.lg}px) {
        ${({isFirstChild}) => isFirstChild && `padding-left: 2rem;`};
    }
`

export const Chip = styled(MUIChip)`
    .MuiTouchRipple-root {
        display: none;
    }

    .MuiChip-label {
        line-height: 1.5;
        font-weight: 400;
        text-transform: none;
        font-size: 0.8125rem;
        padding: 0 0.125rem;
    }
    padding: 0.1875rem 0.375rem;
    border: ${({theme}) => theme.colours.form.disabled.border};
    background-color: ${({theme}) => theme.colours.utilities.backgroundAccent};
    font-size: 0.8125rem;
    height: 2.125rem;
    border-radius: 2.25rem;

    @media (min-width: ${breakpoints.values.lg}px) {
        font-size: 0.75rem;
    }
`
